// 原 CSS Modules 的类名映射，去掉构建哈希以便阅读。
export default {
  chart: "SectionWaterfall__chart",
  section: "SectionWaterfall__section",
  svg: "SectionWaterfall__svg",
};
